export default __webpack_public_path__ + "static/media/f.ff4c62bb.jpg";